import React, { useCallback, useContext, useMemo } from 'react'
import { ReturingCustomersLayoutContext } from '../ReturningCustomersLayout';
import { MainTracker } from '../../../../PixelTrackers/MainTracker';

interface DosageOptionProps {
    dosageStr: string,
    productID: number,
    isColLayout?: boolean,
    isResponsiveLayout?: boolean
}
const DosageOption: React.FC<DosageOptionProps> = ({ dosageStr, productID, isColLayout, isResponsiveLayout }) => {

    const context = useContext(ReturingCustomersLayoutContext);
    const groupedProducts = context?.groupedProducts;
    const selectedCatalogID = context?.selectedCatalogID;
    const selectedProduct = context?.selectedProduct;
    
    const isSelected = useMemo(() => {
        return selectedProduct?.product_id === productID;
    }, [selectedProduct, productID]);
        
        const product = useMemo(() => {
            return groupedProducts && groupedProducts[selectedCatalogID!].find((product) => product.product_id === productID)!;
    }, [selectedCatalogID, productID, groupedProducts]);
    
    const isOutOfStock = product && !product.in_stock;

    const isDisabled = isOutOfStock && !context?.allowPrescriptionOnlyFlow && !product?.is_pre_orderable;
    const productItemToPlan = context?.productItemToPlan;


    const onSelect = useCallback(() => {
        if (groupedProducts && context?.selectedProductID !== productID) {
            const product = groupedProducts[selectedCatalogID!].find((product) => product.product_id === productID)!;
            MainTracker.superProperties({
                "Product Dosage": product.dosage_str || product.product_title,
            });
            window.eventsTracking.track({ e: "Click change Product Dosage" });
            const firstInStockItem = context?.findQuantityBasedOnRule(product) || product.items.find((item) => item.in_stock || context?.allowPrescriptionOnlyFlow || product.is_pre_orderable);

            context?.setSelectedProductID(productID);
            context?.setSelectedProductItemID(firstInStockItem?.product_item_id || null);
            context?.setIsExpressProductItem(firstInStockItem?.express_stock || false);
            if (productItemToPlan) {
                const plans = productItemToPlan[firstInStockItem!.product_item_id]
                if (plans) {
                    context?.setSelectedSubscriptionPlanID(plans[0]);
                } else {
                    context?.setSelectedSubscriptionPlanID(null);
                }
            }
        }
    }, [groupedProducts, context, productID, selectedCatalogID, productItemToPlan]);

    return (
        <div id={`product_${productID.toString()}${isResponsiveLayout ? "_responsive" : ""}`} style={{
            border: (isSelected && !isDisabled) ? "1px solid #269C6E" : "1px solid #e0e0e0",
        }} onClick={isDisabled ? () => { } : onSelect} className={`${(isSelected && !isDisabled) ? "bg-[#F7FAEF] text-[#0d2c54]" : "text-[#808080]"} relative rounded-md font-medium ${isDisabled ? "bg-[#f0eded] cursor-not-allowed" : "cursor-pointer"} flex items-center ${isColLayout ? "w-full" : "max-w-[120px]"} justify-center py-5 px-3`}>
            {(isSelected && !isDisabled) && <span className="absolute top-[-10px] right-[-10px] w-[25px] h-[25px] bg-primary-lightgreen rounded-full flex items-center justify-center text-white text-lg">✓</span>}
            <p>{dosageStr}</p>
        </div>
    )
}

export default DosageOption
